<div>
    <dx-progress-bar #progressBar
                     id="progress-bar-status"
                     width="100%"
                     [height]="15"
                     [value]="false"
                     [visible]="showProgressBar" />
    <form (submit)="onFormSubmit($event)">
        <dx-toolbar class="toolbar-details">
            <dxi-item location="before" locateInMenu="auto">
                <dx-switch width="120"
                           [switchedOffText]="'fileTransfers.lblEditionMode' | translate"
                           [switchedOnText]="'fileTransfers.lblReadMode' | translate"
                           [(value)]="readOnly" />
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto" [visible]="!readOnly">
                <dx-button type="default"
                           icon="save"
                           stylingMode="contained"
                           class="save-button"
                           [text]="'_commons.save' | translate"
                           [useSubmitBehavior]="true" />
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto" [visible]="!newFileTransfer">
                <dx-button icon="copy"
                           stylingMode="contained"
                           type="normal"
                           [text]="'_commons.copy' | translate"
                           (onClick)="copy()" />
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto">
                <div class="separator"></div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto" [visible]="!newFileTransfer">
                <dx-button icon="video"
                           stylingMode="contained"
                           type="normal"
                           [text]="'_commons.execute' | translate"
                           (onClick)="execute()" />
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto" [visible]="!newFileTransfer">
                <div class="separator"></div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto" [visible]="!readOnly && !newFileTransfer && fileTransfer.isDisabled">
                <dx-button icon="check"
                           stylingMode="contained"
                           type="success"
                           [text]="'_commons.enable' | translate"
                           (onClick)="enable()" />
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto" [visible]="!readOnly && !newFileTransfer && !fileTransfer.isDisabled">
                <dx-button icon="clear"
                           stylingMode="contained"
                           type="danger"
                           [text]="'_commons.disable' | translate"
                           (onClick)="disable()" />
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto">
                <div class="separator"></div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="auto" [visible]="!readOnly && !newFileTransfer">
                <dx-button icon="trash"
                           stylingMode="contained"
                           type="danger"
                           [text]="'_commons.delete' | translate"
                           (onClick)="delete()" />
            </dxi-item>
        </dx-toolbar>
        <dx-scroll-view style="height: calc(100vh - 265px);margin-top:5px;">
            <dx-form #fileTransferForm
                     class="scrolled-form"
                     labelLocation="left"
                     labelMode="outside"
                     validationGroup="fileTransferValidation"
                     [colCount]="2"
                     [formData]="fileTransfer"
                     [readOnly]="readOnly"
                     [showColonAfterLabel]="false">
                <dxi-item itemType="group" [caption]="'fileTransfers.lblGeneral' | translate">
                    <dxi-item dataField="name" editorType="dxTextBox">
                        <dxo-label [text]="'fileTransfers.lblTransferName' | translate" />
                        <dxi-validation-rule type="required" [message]="'fileTransfers.msgTransferNameRequired' | translate" />
                        <dxi-validation-rule type="stringLength" [max]="100" message="'_validators.maxLength100' | translate" />
                    </dxi-item>
                    <dxi-item dataField="localAgent.id" editorType="dxSelectBox" [editorOptions]="{ dataSource: currentEnvironmentLocalAgents, displayExpr: 'displayName', searchEnabled: true, valueExpr: 'id' }">
                        <dxo-label [text]="'fileTransfers.lblAgent' | translate" />
                        <dxi-validation-rule type="required" [message]="'_pickers.msgLocalAgentRequired' | translate" />
                    </dxi-item>
                    <dxi-item>
                        <dxo-label [text]="('fileTransfers.lblExecutionMode' | translate) + ' *'" />
                        <div *dxTemplate>
                            <app-execution-mode-picker [readOnly]="readOnly" [(selectedItem)]="fileTransfer.executionMode" />
                        </div>
                    </dxi-item>
                    <dxi-item dataField="executeAfter.id" editorType="dxSelectBox" [editorOptions]="{ dataSource: currentEnvironmentFileTransfersInfo, displayExpr: 'name', searchEnabled: true, valueExpr: 'id', showClearButton: true }">
                        <dxo-label [text]="'fileTransfers.lblExecuteAfter' | translate" />
                    </dxi-item>
                    <dxi-item>
                        <dxo-label [text]="'fileTransfers.lblFileName' | translate" />
                        <div *dxTemplate id="dvFileNamePattern">
                            <dx-text-box [readOnly]="readOnly" [(value)]="fileTransfer.fileNamePattern">
                                <dx-validator>
                                    <dxi-validation-rule type="stringLength" [max]="100" [message]="'_validators.maxLength100' | translate" />
                                </dx-validator>
                            </dx-text-box>
                            <dx-tooltip target="#dvFileNamePattern"
                                        showEvent="dxhoverstart"
                                        hideEvent="dxhoverend">
                                <div *dxTemplate="let data of 'content'">
                                    <div class="tooltipText">
                                        <p class="tooltipTitleText" translate>fileTransfers.lblAuthorizedVariables</p><br />
                                        <span class="tooltipTitleText">%DateTime% : </span><span class="tooltipText">MyFileName-%DateTime%.txt (MyFileName-190618173256.txt)</span><br />
                                        <span class="tooltipTitleText">%DateTimeUtc% : </span><span class="tooltipText">MyFileName-%DateTimeUtc%.txt (MyFileName-190618153256.txt)</span><br />
                                        <span class="tooltipTitleText">%DateTime:<em>format</em>% : </span><span class="tooltipText">MyFileName-%DateTime:yyyyMMdd_HHmmss%.txt (MyFileName-20190618_173256.txt)</span><br />
                                        <span class="tooltipTitleText">%DateTimeUtc:<em>format</em>% : </span><span class="tooltipText">MyFileName-%DateTimeUtc:yyyyMMdd_HHmmss%.txt (MyFileName-20190618_153256.txt)</span><br />
                                        <br />
                                        <p class="tooltipTitleText" translate>fileTransfers.lblDefaultDateTimeFormatApplied</p>
                                        <p class="tooltipTitleText" translate>fileTransfers.lblWildcardsAuthorizedWithVariables</p>
                                    </div>
                                </div>
                            </dx-tooltip>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="renamingParametersSeparator" editorType="dxTextBox">
                        <dxo-label [text]="'fileTransfers.lblRenamingParamSeparator' | translate" />
                        <div *dxTemplate style="width:120px;">
                            <dx-text-box [readOnly]="readOnly" [(value)]="fileTransfer.renamingParametersSeparator">
                                <dx-validator>
                                    <dxi-validation-rule type="stringLength" [max]="10" [message]="'_validators.maxLength10' | translate" />
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="sendFileInNotificationEmail" editorType="dxSwitch">
                        <dxo-label [text]="'fileTransfers.lblSendFileInNotificationEmail' | translate" />
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [caption]="'fileTransfers.lblACK' | translate">
                    <dxi-item dataField="ackManagement" editorType="dxSwitch">
                        <dxo-label [text]="'fileTransfers.lblAckManagement' | translate" />
                    </dxi-item>
                    <dxi-item dataField="ackokExtension" editorType="dxTextBox" *ngIf="fileTransfer.ackManagement">
                        <dxo-label [text]="'fileTransfers.lblAckOkExtension' | translate" />
                        <div *dxTemplate style="width:120px;">
                            <dx-text-box [readOnly]="readOnly" [(value)]="fileTransfer.ackokExtension">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgAckOkRequired' | translate" />
                                    <dxi-validation-rule type="stringLength" [max]="20" [message]="'_validators.maxLength20' | translate" />
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="ackkoExtension" editorType="dxTextBox" *ngIf="fileTransfer.ackManagement">
                        <dxo-label [text]="'fileTransfers.lblAckKoExtension' | translate" />
                        <div *dxTemplate style="width:120px;">
                            <dx-text-box [readOnly]="readOnly" [(value)]="fileTransfer.ackkoExtension">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'fileTransfers.msgAckKoRequired' | translate" />
                                    <dxi-validation-rule type="stringLength" [max]="20" [message]="'_validators.maxLength20' | translate" />
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [caption]="'fileTransfers.lblSource' | translate">
                    <dxi-item dataField="source.id">
                        <dxo-label [text]="'_commons.platform' | translate" />
                        <div *dxTemplate style="width:100%">
                            <dx-select-box class="platform-selector"
                                           displayExpr="displayName"
                                           valueExpr="id"
                                           [dataSource]="currentEnvironmentRemotePlatforms"
                                           [readOnly]="readOnly"
                                           [searchEnabled]="true"
                                           [showClearButton]="true"
                                           [value]="fileTransfer.source?.id"
                                           (onSelectionChanged)="onSourcePlatformChanged($event)"/>
                            <dx-button icon="find"
                                       stylingMode="text"
                                       type="normal"
                                       [disabled]="!fileTransfer.source"
                                       [hint]="'fileTransfer.checkConnectionToSource' | translate"
                                       (onClick)="checkConnectionToSource()" />
                        </div>
                    </dxi-item>
                    <dxi-item dataField="sourceFolder" editorType="dxTextBox">
                        <dxo-label [text]="'_commons.folder' | translate" />
                        <dxi-validation-rule type="required" [message]="'fileTransfers.msgSourceFolderRequired' | translate" />
                        <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate" />
                        <dxi-validation-rule type="custom" [message]="getSourceFolderValidatorFormat()" [validationCallback]="validateSourceFolderFormat" />
                    </dxi-item>

                    <dxi-item dataField="decryptionKey.id" editorType="dxSelectBox" [editorOptions]="{ dataSource: currentEnvironmentDecryptionKeys, displayExpr: 'name', searchEnabled: true, valueExpr: 'id', showClearButton: true }">
                        <dxo-label [text]="'fileTransfers.lblDecryptFile' | translate" />
                    </dxi-item>
                    <dxi-item dataField="deleteTransferredFileFromSource" editorType="dxSwitch">
                        <dxo-label [text]="'fileTransfers.lblDeleteTransferredFiles' | translate" />
                    </dxi-item>
                    <dxi-item dataField="ignoreEmptyFiles" editorType="dxSwitch" [editorOptions]="ignoreEmptyFilesOptions">
                        <dxo-label [text]="'fileTransfers.lblIgnoreEmptyFiles' | translate" />
                    </dxi-item>
                    <dxi-item dataField="removeEmptyFiles" editorType="dxSwitch" [editorOptions]="removeEmptyFilesOptions">
                        <dxo-label [text]="'fileTransfers.lblRemoveEmptyFiles' | translate" />
                    </dxi-item>
                    <dxi-item dataField="createLogForIgnoredEmptyFiles" editorType="dxSwitch" [editorOptions]="createLogForIgnoredEmptyFilesOptions">
                        <dxo-label [text]="'fileTransfers.lblCreateLogForIgnoredEmptyFiles' | translate" />
                    </dxi-item>
                    <dxi-item>
                        <dxo-label [text]="'_commons.tags' | translate" />
                        <div *dxTemplate>
                            <dx-tag-box placeholder=""
                                        [acceptCustomValue]="true"
                                        [dataSource]="tags"
                                        [noDataText]="'tags.noExistingTag' | translate"
                                        [readOnly]="readOnly"
                                        [searchEnabled]="true"
                                        [showClearButton]="true"
                                        [showSelectionControls]="true"
                                        [(value)]="fileTransfer.sourceTags" />
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [caption]="'fileTransfers.lblTarget' | translate">
                    <dxi-item dataField="target.id">
                        <dxo-label [text]="'_commons.platform' | translate" />
                        <div *dxTemplate style="width:100%">
                            <dx-select-box class="platform-selector"
                                           displayExpr="displayName"
                                           valueExpr="id"
                                           [dataSource]="currentEnvironmentRemotePlatforms"
                                           [readOnly]="readOnly"
                                           [searchEnabled]="true"
                                           [showClearButton]="true"
                                           [value]="fileTransfer.target?.id"
                                           (onSelectionChanged)="onTargetPlatformChanged($event)"/>
                            <dx-button icon="find"
                                       stylingMode="text"
                                       type="normal"
                                       [disabled]="!fileTransfer.target"
                                       [hint]="'fileTransfer.checkConnectionToTarget' | translate"
                                       (onClick)="checkConnectionToTarget()" />
                        </div>
                    </dxi-item>
                    <dxi-item dataField="targetFolder" editorType="dxTextBox">
                        <dxo-label [text]="'_commons.folder' | translate" />
                        <dxi-validation-rule type="required" [message]="'fileTransfers.msgTargetFolderRequired' | translate" />
                        <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate" />
                        <dxi-validation-rule type="custom" [message]="getTargetFolderValidatorFormat()" [validationCallback]="validateTargetFolderFormat" />
                    </dxi-item>
                    <dxi-item dataField="encryptionKey.id" editorType="dxSelectBox" [editorOptions]="{ dataSource: currentEnvironmentEncryptionKeys, displayExpr: 'name', searchEnabled: true, valueExpr: 'id', showClearButton: true }">
                        <dxo-label [text]="'fileTransfers.lblEncryptFile' | translate" />
                    </dxi-item>
                    <dxi-item dataField="extractZipArchiveInTargetFolder" editorType="dxSwitch" [editorOptions]="extractZipArchiveInTargetFolderOptions">
                        <dxo-label [text]="'fileTransfers.lblExtractZipArchiveInTargetFolder' | translate" />
                    </dxi-item>
                    <dxi-item dataField="overwriteFileInTargetFolder" editorType="dxSwitch" [editorOptions]="overwriteFileInTargetFolderOptions">
                        <dxo-label [text]="'fileTransfers.lblOverwriteFileInTargetFolder' | translate" />
                    </dxi-item>
                    <dxi-item dataField="replaceUnixLineFeedCharacter" editorType="dxSwitch" [editorOptions]="replaceUnixLineFeedCharacterOptions">
                        <dxo-label [text]="'fileTransfers.lblReplaceUnixLineFeedCharacters' | translate" />
                    </dxi-item>
                    <dxi-item dataField="replaceSpecialCharactersInFileName" editorType="dxSwitch" [editorOptions]="replaceSpecialCharactersInFileNameOptions">
                        <dxo-label [text]="'fileTransfers.lblReplaceSpecialCharFileName' | translate" />
                    </dxi-item>
                    <dxi-item dataField="ackFolder" editorType="dxTextBox" *ngIf="fileTransfer.ackManagement">
                        <dxo-label [text]="'fileTransfers.lblAckFolder' | translate" />
                        <dxi-validation-rule type="required" [message]="'fileTransfers.msgAckFolderRequired' | translate" />
                        <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate" />
                        <dxi-validation-rule type="custom" [message]="getAckFolderValidatorFormat()" [validationCallback]="validateAckFolderFormat" />
                    </dxi-item>
                    <dxi-item>
                        <dxo-label [text]="'_commons.tags' | translate" />
                        <div *dxTemplate>
                            <dx-tag-box placeholder=""
                                        [acceptCustomValue]="true"
                                        [dataSource]="tags"
                                        [noDataText]="'tags.noExistingTag' | translate"
                                        [readOnly]="readOnly"
                                        [searchEnabled]="true"
                                        [showClearButton]="true"
                                        [showSelectionControls]="true"
                                        [(value)]="fileTransfer.targetTags" />
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [caption]="'fileTransfers.lblArchives' | translate">
                    <dxi-item dataField="archives.id">
                        <dxo-label [text]="'_commons.platform' | translate" />
                        <div *dxTemplate style="width:100%">
                            <dx-select-box class="platform-selector"
                                           displayExpr="displayName"
                                           valueExpr="id"
                                           [dataSource]="currentEnvironmentRemotePlatforms"
                                           [readOnly]="readOnly"
                                           [searchEnabled]="true"
                                           [showClearButton]="true"
                                           [value]="fileTransfer.archives?.id" 
                                           (onSelectionChanged)="onArchivesPlatformChanged($event)"/>
                            <dx-button icon="find"
                                       stylingMode="text"
                                       type="normal"
                                       [disabled]="!fileTransfer.archives"
                                       [hint]="'fileTransfer.checkConnectionToArchive' | translate"
                                       (onClick)="checkConnectionToArchives()" />
                        </div>
                    </dxi-item>
                    <dxi-item dataField="archivesFolder" editorType="dxTextBox">
                        <dxo-label [text]="'_commons.folder' | translate" />
                        <dxi-validation-rule type="stringLength" [max]="1000" [message]="'_validators.maxLength1000' | translate" />
                        <dxi-validation-rule type="custom" [message]="getArchivesFolderValidatorFormat()" [validationCallback]="validateArchivesFolderFormat" />
                    </dxi-item>
                    <dxi-item dataField="renameOnlyArchivedFiles" editorType="dxSwitch">
                        <dxo-label [text]="'fileTransfers.lblRenameOnlyArchivedFiles' | translate" />
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </dx-scroll-view>
    </form>
</div>

<!-- File transfer execution popup -->
<app-file-transfer-execution #fileTransferExecution />
<!-- Check Connection popup -->
<app-local-agent-check-connection #checkConnectionPopup [allowChangeAgent]="true"/>